export default "__VITE_ASSET__Duy_7cZB__"